export const engagementInAppMessageColorProfilesTerritories =
  "/engagement/in_app_message_color_profiles/territories";
